import axios from "./axios";

// Register user with SnapTrade
export const registerSnapTradeUser = () => {
  return axios.post("/api/snaptrade/register/");
};

// Get SnapTrade auth link
export const getSnapTradeAuthLink = () => {
  return axios.get("/api/snaptrade/auth-link/");
};

// Get linked brokerage accounts
export const getSnapTradeAccounts = () => {
  return axios.get("/api/snaptrade/accounts/");
};

// Delete brokerage account
export const deleteSnapTradeAccount = (accountId) => {
  return axios.delete(`/api/snaptrade/accounts/${accountId}/`);
};

// Get holdings/positions
export const getSnapTradeHoldings = () => {
  return axios.get("/api/snaptrade/holdings/");
};

// Sync holdings from SnapTrade to database
export const syncSnapTradeHoldings = () => {
  return axios.post("/api/snaptrade/holdings/sync/");
};
